export var featureFlags = {
    'proctoring_logs': false,
    'new_online_test_list': false,
    'new_finished_test_list': false,
    'new_upcoming_test_list': false,
};

let callbacks = [];
let clientReady = false;
let optimizelyInstance = null;
let userAttributes = null;

export function initOptimizelyClient() {
    const optimizelySDK = require('@optimizely/optimizely-sdk');
    optimizelySDK.setLogLevel('error');
    const instance = optimizelySDK.createInstance({
        sdkKey: process.env.VUE_APP_OPTIMIZELY_SDK_KEY
    });
    instance.onReady().then(() => {
        optimizelyInstance = instance;
        if (userAttributes !== null) {
            evaluateAndNotify();
        }
    });
}

export function setOptimizelyUserAttributes(attributes) {
    userAttributes = attributes;
    if (optimizelyInstance) {
        evaluateAndNotify();
    }
}

function evaluateAndNotify() {
    for (const [key] of Object.entries(featureFlags)) {
        featureFlags[key] = optimizelyInstance.isFeatureEnabled(key, '', userAttributes);
    }
    clientReady = true;
    callbacks.forEach((callback) => { callback(); });
    callbacks = [];
}

export function onClientReady(fn) {
    if (clientReady) {
        fn();
    } else {
        callbacks.push(fn);
    }
}
